import { LoaderFunctionArgs } from "react-router";
import { handleApiFetch } from "../../utils";

export async function historyDiffLoader({ params, context: loaderContext }: LoaderFunctionArgs<any>) {
    let context = loaderContext;
    if (typeof window !== "undefined" && window.__client_context) {
        context = window.__client_context
    }
    
    if (context == null) return {}

    const { revision } = params;
    const articleRevision = await handleApiFetch(
        context.env,
        `/wiki/history?revision=${revision}`,
        null,
        context['info']
    )

    const lastRevision = articleRevision && articleRevision.revisions["before"] ? await handleApiFetch(
        context.env,
        `/wiki/history?revision=${articleRevision.revisions["before"]}`,
        null,
        context['info']
    ) : undefined

    return {
        revision: articleRevision,
        before: lastRevision
    }
}